import TcListPage from 'components/UI/TcListPage/TcListPage';
import TcButton from 'components/UI/button/TcButton';
import TcPageTitle from 'components/UI/pageTitle/TcPageTitle';
import BranchCustomerProductCreate from 'components/pages/dashboard/branchCustomerProductType/components/BranchCustomerProductCreate';
import endpointUrls from 'global/Constants/endpointUrls';
import branchCustomerProductTypeModel from 'global/Models/branchCustomerProductTypeModel';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { productTypeList } from 'global/Models/productTypeModel';
import { handleApiThen, handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import useQuery from 'global/helperFunctions/useQuery';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useMemo, useState } from 'react';

const BranchCustomerProductList: FC = () => {
  const [list, setList] = useState<IBackendSearchGeneric<productTypeList> | undefined>();
  const [loading, setLoading] = useState<boolean>(false);
  const [isCreateModalVisible, setCreateModalVisible] = useState<boolean>(false);
  const [_editableRecord, setEditableRecord] = useState<productTypeList | undefined>();
  const { query } = useQuery();

  const getList = async (payload: Record<string, any>) => {
    setLoading(true);
    await ApiService.post(endpointUrls.branchCustomerProductList, { ...payload })
      .then((res: IBackendSearchGeneric<productTypeList>) =>
        handleApiThenGeneric<IBackendSearchGeneric<productTypeList>, productTypeList[]>({
          res,
          notifFail: false,
          notifSuccess: false,
          onSuccess: (response) => setList(response),
          onFailed: () => setList(undefined),
        })
      )
      .catch(() => setList(undefined));
    setLoading(false);
  };

  const handleDelete = async (id: number | string) => {
    setLoading(true);
    await ApiService.put(endpointUrls.branchCustomerProductDelete(id))
      .then((res: any) =>
        handleApiThen({
          res,
          notifFail: true,
          notifSuccess: true,
          onSuccess: () => getList(query),
        })
      )
      .catch(() => localApiCatcher(errorResponse));
    setLoading(false);
  };

  const columns = useMemo(() => branchCustomerProductTypeModel.columns({ handleDelete, handleEdit: (record: any) => setEditableRecord(record) }), [handleDelete]);

  const toggleCreateModal = () => setCreateModalVisible((prev) => !prev);

  return (
    <>
      <TcPageTitle title={branchCustomerProductTypeModel.title} moreContent={<TcButton onClick={toggleCreateModal}>ایجاد نوع کالا در انبار</TcButton>} />
      <TcListPage columns={columns} list={list} getList={getList} loading={loading} filterItems={branchCustomerProductTypeModel.filterItems} />
      <BranchCustomerProductCreate visible={isCreateModalVisible} close={toggleCreateModal} refetch={() => getList(query)} />
    </>
  );
};

export default BranchCustomerProductList;
